import { CashDeliveryFilterData } from '@oy/types';
import update from 'immutability-helper';
import { ActionType, defaultAction } from 'src/redux/types';
import keyMirror from 'src/utilities/keyMirror';

export const ACTION_TYPES = keyMirror({
  TOGGLE_MODAL: null,
  CHANGE_AMOUNT: null,
  CHANGE_ID: null,
  CHANGE_TX_ID: null,
  CHANGE_FILTER: null,
});

export type CashDeliveryState = {
  isShowCreateModal: boolean;
  totalAmount: number;
  modalData: string;
  selectedTxId: string;
  filterData: CashDeliveryFilterData;
};

const initialState: CashDeliveryState = {
  isShowCreateModal: false,
  totalAmount: 0,
  modalData: '',
  selectedTxId: '',
  filterData: {
    status: '',
    end_date: undefined,
    payment_type: undefined,
    start_date: undefined,
    tx_id: '',
  },
};

export default (state = initialState, action: ActionType = defaultAction) => {
  const { payload, type } = action;
  switch (type) {
    case ACTION_TYPES.TOGGLE_MODAL:
      return update(state, {
        isShowCreateModal: {
          $set: payload,
        },
      });
    case ACTION_TYPES.CHANGE_AMOUNT:
      return update(state, {
        totalAmount: {
          $set: payload,
        },
      });
    case ACTION_TYPES.CHANGE_ID:
      return update(state, {
        modalData: {
          $set: payload,
        },
      });
    case ACTION_TYPES.CHANGE_TX_ID:
      return update(state, {
        selectedTxId: {
          $set: payload,
        },
      });
    case ACTION_TYPES.CHANGE_FILTER:
      return update(state, {
        filterData: {
          $set: payload,
        },
      });
    default:
      return state;
  }
};
